module.exports = __webpack_public_path__ + "img/firmador-lyris-signar-title-2.28448873.webp";